import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import * as API from '../core/api';
import MainInfo from './MainInfo';
import Projects from './Projects';
import Goals from './Goals';
import Render from '../common/Render';
import User from './class';

class Screen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      user: this.props.user,
      error: null,
    };
  }

  fetchUser = (userId) => {
    API.get(`users/${userId}`)
      .then((user) => this.setState({ user: new User(user) }))
      .catch((error) => this.setState({ error }))
      .finally(() => this.setState({ isLoading: false }));
  };

  requestUserDataIfNeeded = () => {
    // Okay, that's a bit ugly, I agree.
    // However, that's the fastest way I found to do this kind of magic.
    const { userId } = this.props.match.params;
    if (!userId) {
      // This is the current user. Do nothing more.
      this.setState({
        user: this.props.user,
        isLoading: false,
      });
    } else {
      // This is not the currently logged-in user. Fetch user details!
      this.fetchUser(userId);
    }
  };

  componentDidMount() {
    this.requestUserDataIfNeeded();

    // On route change, request user data again,
    // to make sure everything is up to date.
    this.props.history.listen((location, action) => {
      this.setState({ isLoading: true }, () => {
        this.requestUserDataIfNeeded();
      });
    });
  }

  renderAfterLoading = () => {
    const { user } = this.state;
    const { t } = this.props;

    return (
      <React.Fragment>
        <MainInfo user={user} />
        <Projects
          user={user}
          titlePrefix={t('user.projectsTitlePrefix')}
          title={t('user.projectsTitle')}
          titleSuffix={t('user.projectsTitleSuffix')}
          titlePrefixColor="u-color-blue-violet"
          type="DEFAULT"
          status="ACTIVE"
        />
        <Projects
          user={user}
          titlePrefix={t('user.sideProjectsTitlePrefix')}
          title={t('user.sideProjectsTitle')}
          titleSuffix={t('user.sideProjectsTitleSuffix')}
          titlePrefixColor="u-color-shakespeare"
          type="SIDE"
          status="ACTIVE"
        />

        <div id="goals">
          <Goals user={user} />
        </div>

        <Projects
          user={user}
          titlePrefix={t('user.archievedProjectsTitlePrefix')}
          title={t('user.archievedProjectsTitle')}
          titleSuffix={t('user.archievedProjectsTitleSuffix')}
          titlePrefixColor="u-color-gray"
          titleColor="u-color-gray"
          type={['DEFAULT', 'SIDE']}
          status="INACTIVE"
          enableCreateNew={false}
          forceRendering={false}
        />
      </React.Fragment>
    );
  };

  render() {
    const { isLoading, error } = this.state;

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}
const mapStateToProps = ({ user }) => ({ user: user.data });

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(translate()(Screen))
);



// WEBPACK FOOTER //
// ./src/user/Screen.js